angular.module('unergie.main')
.directive('userInfoContractOverdue', (TableGeneratorService, BoFeaturesService, ApiUser, AlertManager, ErrorCatcher, MetaWatcher, OverdueProcessUtilsService) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractOverdue.html',
        link($scope) {
            const feats = BoFeaturesService.getModuleFeatures('overdues')
            const aiFeatures = BoFeaturesService.getModuleFeatures('accountinfo')
            $scope.adminLink = feats.adminLink

            $scope.overdues = {
                columns: {
                    process_name: { label: 'Process', mode: 'search_wildcard' },
                    step: { label: 'Etape', mode: 'filter_only' },
                    simpleStatus: { label: 'Status', mode: 'filter_only' },
                    status: { label: 'Statut Brut', mode: 'search_wildcard' },
                    rawStatus: { label: 'Statut brut', mode: 'search_wildcard' },
                    start_date: { label: 'Date de début', mode: 'search_date' },
                    next_step_date: { label: 'Prochaine date', mode: 'search_date' },
                },
            }

            $scope.isAIFeatureOn = (feature) => aiFeatures[feature]

            $scope.refresh = function () {
                const transformData = (data) =>
                    data.forEach((overdue) => {
                        const display = OverdueProcessUtilsService.getOverdueStatusMapping(overdue.status)
                        overdue.simpleStatus = display.simpleStatus
                        overdue.step = display.step
                        overdue.statusColor = display.color
                    })

                return TableGeneratorService.getTable($scope.overdues, 'overdue-processes', '', transformData, { search: { id_contract: $scope.contract.id } })
            }

            $scope.showButtons = (overdue) => (overdue.status.indexOf('CANCELLED_') === -1) && (overdue.status.indexOf('FINISHED_') === -1) && (overdue.status !== 'TERMINATION_NOTIF_SENT')

            // ACTIONS
            $scope.delayFields = {
                wait_until: {
                    label: 'Jusqu\'au',
                    type: 'date',
                },
            }

            $scope.setWaitUntil = (overdue) => { overdue.wait_until = moment().toDate() }

            $scope.delayProcess = (overdue) =>
                ApiUser.delayOverdue({ id: overdue.id }, { wait_until: moment(overdue.wait_until).format('YYYY-MM-DD') }).$promise.then(() =>
                    AlertManager.success('Processus mis en pause'))
                .catch(ErrorCatcher)
                .finally(() => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract))


            $scope.cancelProcess = (overdue) =>
                ApiUser.cancelOverdue({ id: overdue.id }).$promise.then(() =>
                    AlertManager.success('Processus annulé'))
                .catch(ErrorCatcher)
                .finally(() => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract))

            $scope.killProcess = (overdue) =>
                ApiUser.killOverdueProcess({ id: overdue.id }).$promise.then(() =>
                    AlertManager.success('Processus supprimé'))
                .catch(ErrorCatcher)
                .finally(() => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract))


            // ON CONTROLLER INIT
            const activate = () => $scope.refresh()

            return activate()
        },
    })
)
